import { useDashboardConfig } from '../../hooks/useDashboardConfig';

import { RoutesPaths } from '@/router/constants';

import { IDashboardConfig } from '@/store/models/dashboard-config.model';

function parseKeys(obj: any, path: string, key?: string) {
  if (typeof obj === 'string') {
    if (key === 'root' || key === 'all') {
      return `${path}${obj.replace(path, '')}`;
    } else {
      return obj;
    }
  } else {
    Object.keys(obj).map((key) => {
      obj[key] = parseKeys(obj[key], path, key);
    });
  }

  return obj;
}

export function useRoutepaths(): typeof RoutesPaths | undefined {
  const config = useDashboardConfig();
  if (config && config?.site?.path !== undefined) {
    return parseKeys(RoutesPaths, config?.site?.path);
  }
  return undefined;
}

export function getRoutepaths(config: IDashboardConfig): typeof RoutesPaths | undefined {
  return parseKeys(RoutesPaths, config?.site?.path);
}
